import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConsoleSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconConsoleSimple"><Path d="M4.5 6.5L10 12L4.5 17.5M12.5 17.5H19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconConsoleSimple;
